import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["button", [`button--${$props.size}`]])
  }, [
    ($props.size === 'kerleise')
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          name: "play-solid_32"
        }))
      : ($props.size === 'crotheise')
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 1,
            name: "play-solid_20"
          }))
        : (_openBlock(), _createBlock(_component_Icon, {
            key: 2,
            name: "play-solid_16"
          }))
  ], 2))
}